import { render, staticRenderFns } from "./GeneralPathLandingPage.vue?vue&type=template&id=1cb3f471&scoped=true&"
import script from "./GeneralPathLandingPage.vue?vue&type=script&lang=ts&"
export * from "./GeneralPathLandingPage.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralPathLandingPage.vue?vue&type=style&index=0&id=1cb3f471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3f471",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1cb3f471', component.options)
    } else {
      api.reload('1cb3f471', component.options)
    }
    module.hot.accept("./GeneralPathLandingPage.vue?vue&type=template&id=1cb3f471&scoped=true&", function () {
      api.rerender('1cb3f471', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/GeneralPathLandingPage.vue"
export default component.exports